import { RateType } from '~/features/Rates/enums'

export const setRateCardImage = (avatar: string, type: string) => {
  if (avatar) {
    return avatar
  }

  if (type === RateType.Clinic) {
    return '/graphics/no-avatar-clinic.svg'
  }

  if (type === RateType.Doctor) {
    return '/graphics/no-avatar-doctor.svg'
  }
}
